import { useSelector } from "react-redux";
import './Loader.scss';

const Loader = () => {

  const visible = useSelector(state => state.interaction.loader.visible);

  return <>
    { visible && <div className="loader-container">
      <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div> }
  </>
}

export default Loader;